/* eslint-disable no-restricted-globals */
import React, { useContext, useState } from "react"
import { useTranslation } from "react-i18next"
import { Flex, Text } from "theme-ui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faPlug,
  faPlugCircleXmark,
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons"

import IntegrationIconDisplay from "../IntegrationIconDisplay/IntegrationIconDisplay"
import ChannelHooksPanel from "./OutboundHooks/ChannelHooksPanel"
import { isJSONString } from "../util"

import {
  useMutation
} from "react-relay"
import {
  ConnectChannelMutation,
  DisconnectChannelMutation,
} from "./SettingsModalQuery"
import { UserContext } from "../../contexts/UserContext"

import * as  Styles from "./SettingsModalStyles"

// Deployment kill switch (mirrors ConversationHistory / SettingsOrganizationConfig):
// when set, the per-channel outbound-hook attach UI is hidden entirely.
const DISABLE_OUTBOUND_HOOKS = isJSONString(process.env.REACT_APP_DISABLE_OUTBOUND_HOOKS) ? JSON.parse(process.env.REACT_APP_DISABLE_OUTBOUND_HOOKS) : false

const ChannelRow = ({
  channel,
  appHooks = [],
  onError
}) => {
  const { isAdmin, isSuperAdmin, isSuperAuditor } = useContext(UserContext)
  const canEditHooks = isAdmin || isSuperAdmin
  const attachedCount = channel?.outboundHooks?.length || 0
  const showHooksExpander = !DISABLE_OUTBOUND_HOOKS && (canEditHooks || attachedCount > 0)
  const [hooksExpanded, setHooksExpanded] = useState(false)
  const { t } = useTranslation(["settings", "common"])
  const [connectChannel, isInFlightConnectChannel] = useMutation(
    ConnectChannelMutation
  )
  const [disconnectChannel, isInFlightDisconnectChannel] = useMutation(
    DisconnectChannelMutation
  )

  const connectChannelFunction = ({
    wChannelId,
  }) => {
    let clientMutationId = 0
    const mutationParams = {
      variables: {
        input: {
          wChannelId,
          clientMutationId: clientMutationId++,
        },
      },
      onCompleted: (response, errs) => {
        if (!response.connectChannel?.error) {
        } else {
          const somethingWentWrong = t?.("common:errors.something_went_wrong")
          onError(response.connectChannel?.error?.message || somethingWentWrong)
        }
      },
      onError: (err) => {
        const errorMsg = err.res?.json?.errors[0]?.message || err
        onError(errorMsg)
      }
    }
    connectChannel(mutationParams)
  }

  const disconnectChannelFunction = ({
    wChannelId,
  }) => {
    let clientMutationId = 0
    const mutationParams = {
      variables: {
        input: {
          wChannelId,
          clientMutationId: clientMutationId++,
        },
      },
      onCompleted: (response, errs) => {
        if (!response.disconnectChannel?.error) {
        } else {
          const somethingWentWrong = t?.("common:errors.something_went_wrong")
          onError(response.disconnectChannel?.error?.message || somethingWentWrong)
        }
      },
      onError: (err) => {
        const errorMsg = err.res?.json?.errors[0]?.message || err
        onError(errorMsg)
      }
    }
    disconnectChannel(mutationParams)
  }

  return (
    <>
      <Styles.FlexRow>
        <td className="status">
          <Styles.StatusTag isConnected={channel?.connected}>
            {channel?.connected ?
              t?.("channels_settings.connected")
              :
              t?.("channels_settings.not_connected")
            }
          </Styles.StatusTag>
        </td>
        <td className="channel">
          <Flex sx={{ alignItems: "center"}}>
            {showHooksExpander &&
              <FontAwesomeIcon
                icon={hooksExpanded ? faChevronDown : faChevronRight}
                style={{ cursor: "pointer", marginRight: "10px", width: "12px", color: "#a0aec0" }}
                onClick={() => setHooksExpanded((v) => !v)}
                title={t?.("outbound_hooks.channel.toggle", "Outbound hooks")}
              />
            }
            <IntegrationIconDisplay
              icon={channel?.integrationIcon}
              size="32px"
              name={channel?.integrationName}
            />
            <Flex pl={2} sx={{ flexDirection: "column" }}>
              <Text className="name">{channel?.name}</Text>
              <Text className="wchannel-id">{t?.("channels_settings.channel_id")} {channel?.wChannelId}</Text>
            </Flex>
          </Flex>
        </td>
        <td className="connect">
          <Styles.ConnectButton
            primary
            disabled={isSuperAdmin || isSuperAuditor}
            inverted={channel?.connected}
            text={channel?.connected ? t?.("common:buttons.disconnect"): t?.("common:buttons.connect")}
            icon={channel?.connected ? faPlugCircleXmark : faPlug}
            loading={isInFlightConnectChannel || isInFlightDisconnectChannel}
            onClick={() => {
              if (channel?.connected) {
                disconnectChannelFunction({ wChannelId: channel?.wChannelId })
              }
              else {
                connectChannelFunction({ wChannelId: channel?.wChannelId })
              }
            }}
          />
        </td>
      </Styles.FlexRow>
      {hooksExpanded && showHooksExpander &&
        <tr>
          <td colSpan="3" style={{ padding: 0 }}>
            <ChannelHooksPanel
              channel={channel}
              appHooks={appHooks}
              canEdit={canEditHooks}
            />
          </td>
        </tr>
      }
    </>
  )
}

export default ChannelRow
